import { render, staticRenderFns } from "./mo-modal.html?vue&type=template&id=4925f5bc&external"
import script from "./mo-modal.ts?vue&type=script&lang=ts&external"
export * from "./mo-modal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports